import ActionTypes from "../Actions/ActionTypes";

let initialState = {
  PlanningTemplates: [],
  VendorEvents: [],
  SectionList: [],
  SubSectionList: [],
  QuestionList: [],
  PublicTemplates: [],
  ViewResult: {},
  WeddingPlannerTemplates: [],
};

const PlanningTemplatesReducer = (state = initialState, action) => {
  // console.log("stateeeReducerr", state);
  // console.log("actionReducer", action);
  switch (action.type) {
    case ActionTypes.GET_VENDOR_EVENTS:
      state = { ...state, VendorEvents: action.payload };
      break;

    case ActionTypes.GET_PLANNING_TEMPLATES:
      state = { ...state, PlanningTemplates: action.payload };
      break;

    case ActionTypes.GET_WEDDING_PLANNING_TEMPLATES:
      state = { ...state, WeddingPlannerTemplates: action.payload };
      break;

    case ActionTypes.CREATE_PLANNING_TEMPLATES:
      let Planning_Templates_List_Copy = [...state.PlanningTemplates];
      Planning_Templates_List_Copy.unshift(action.payload);
      state = {
        ...state,
        PlanningTemplates: Planning_Templates_List_Copy,
      };
      break;

    case ActionTypes.GET_SECTION:
      state = { ...state, SectionList: action.payload };
      break;

    case ActionTypes.CREATE_SECTION:
      let Sction_List_Copy = [...state.SectionList];
      Sction_List_Copy.unshift(action.payload);
      state = {
        ...state,
        SectionList: Sction_List_Copy,
      };
      break;

    case ActionTypes.UPDATE_SECTION:
      let Update_Section_List_Copy = [...state.SectionList];
      let index = Update_Section_List_Copy.findIndex(
        (item) => item?.id == action?.payload?.id,
      );
      Update_Section_List_Copy.splice(index, 1, action?.payload);
      state = {
        ...state,
        SectionList: Update_Section_List_Copy,
      };
      break;

    case ActionTypes.DELETE_SECTION:
      let Delete_Section_List_Copy = [...state.SectionList];
      let indexDel = Delete_Section_List_Copy.findIndex(
        (item) => item?.id == action?.payload,
      );
      Delete_Section_List_Copy.splice(indexDel, 1);
      state = {
        ...state,
        SectionList: Delete_Section_List_Copy,
      };
      break;
    //sub sections
    case ActionTypes.GET_SUB_SECTION:
      state = { ...state, SubSectionList: action.payload };
      break;
    case ActionTypes.CREATE_SUB_SECTION:
      let SubSction_List_Copy = [...state.SectionList];
      SubSction_List_Copy.unshift(action.payload);
      state = {
        ...state,
        SectionList: SubSction_List_Copy,
      };
      break;

    case ActionTypes.GET_QUESTION:
      state = { ...state, QuestionList: action.payload };
      break;

    case ActionTypes.CREATE_QUESTION:
      let Question_List_Copy = [...state.QuestionList];
      Question_List_Copy.unshift(action.payload);
      state = {
        ...state,
        QuestionList: Question_List_Copy,
      };
      break;
    case ActionTypes.CLEAR_QUESTION:
      state = { ...state, QuestionList: [] };
      break;

    case ActionTypes.UPDATE_QUESTION:
      let Update_Question_List_Copy = [...state.QuestionList];
      let indexUp = Update_Question_List_Copy.findIndex(
        (item) => item?.id == action?.payload?.id,
      );
      Update_Question_List_Copy.splice(indexUp, 1, action?.payload);
      state = {
        ...state,
        QuestionList: Update_Question_List_Copy,
      };
      break;

    case ActionTypes.DELETE_QUESTION:
      let Delete_Question_List_Copy = [...state.QuestionList];
      let indDel = Delete_Question_List_Copy.findIndex(
        (item) => item?.id == action?.payload,
      );
      Delete_Question_List_Copy.splice(indDel, 1);
      state = {
        ...state,
        QuestionList: Delete_Question_List_Copy,
      };
      break;

    case ActionTypes.GET_PUBLIC_TEMPLATES:
      state = { ...state, PublicTemplates: action.payload };
      break;
    case ActionTypes.GET_VIEW_RESULT:
      state = { ...state, ViewResult: action?.payload };
      break;
    default:
      break;
  }
  return state;
};

export default PlanningTemplatesReducer;
